import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
import { Link, useNavigate, useParams } from 'react-router-dom'
import MapContext from '../../Components/MapContext';
import toast from 'react-simple-toasts';
import axios from 'axios';
import BaseUrl from '../../BaseUrl';


const EditBlog = () => {


    const navigate = useNavigate()
    const { id } = useParams()






    const [name, setName] = useState(null)
    const [descr, setDescr] = useState(null)
    const [image, setImage] = useState(null)







    const [data, setData] = useState({})


    useEffect(() => {
        try {

            axios.get(`${BaseUrl.baseUrl}/blog/get/${id}`).then(res => {
                if (res.data.status === 'ok') {
                    setData(res.data.data)
                    setName(res.data.data.name)
                    setDescr(res.data.data.descr)
                }
                else if (res.data.status === 'fail') {
                    toast('🚩' + res.data.message)
                }

            }).catch(err => {
                toast('🚨' + err.message)
            })


        } catch (err) {
            toast('🚨 Something went wrong!')
        }

    }, [])









    const submit = () => {
        try {


            const param = new FormData()


            if (image) {
                param.append('image', image)
            }

            if (name !== data?.name) {
                param.append('name', name)
            }

            if (descr !== data?.descr) {
                param.append('descr', descr)
            }


            axios.put(`${BaseUrl.baseUrl}/blog/update/${id}`, param).then(res => {
                if (res.data.status === 'ok') {
                    toast('🎉 Updated Successfully!')
                    navigate(-1)
                }
                else if (res.data.status === 'fail') {
                    toast('🚩' + res.data.message)
                }

            }).catch(err => {
                toast('🚨' + err.message)
            })


        } catch (err) {
            toast('🚨 Something went wrong!')
        }



    }



    return (
        <div id="content" className="app-content ms-0">
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="#">Pages</Link>
                        </li>
                        <li className="breadcrumb-item active">Blog</li>
                    </ul>
                    <h1 className="page-header mb-0">Blog</h1>
                </div>
                <div className="ms-auto">
                    <Link to="/showBlogs" className="btn btn-theme fs-13px fw-semibold ">
                        Show Blog
                    </Link>
                </div>
            </div>
            <div className="row gx-4">
                <div className="col-xl-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="response-message" />
                            <div >

                                <div className="mb-2 mt-3">
                                    
                                    
                                    <>
                                        <label htmlFor="">Image</label>
                                        <br />
                                        <input
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className="form-control"
                                            required=""
                                            onChange={(e) => { setImage(e.target.files[0]) }}
                                        />
                                    </>


                                    <img src={image?URL.createObjectURL(image):data?.image} style={{ width: '120px', height: '120px', borderRadius: '200px', marginTop:'5px' }} />
                                </div>

                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Name</label>
                                    <br />
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        className="form-control"
                                        required=""
                                        defaultValue={name}
                                        onChange={(e) => { setName(e.target.value) }}
                                    />
                                </div>
                                <div className="mb-2 mt-3">
                                    <label htmlFor="">Description</label> <br />
                                    <textarea
                                        type="text"
                                        name="description"
                                        placeholder="Description"
                                        className="form-control"
                                        required=""
                                        defaultValue={descr}
                                        onChange={(e) => { setDescr(e.target.value) }}
                                    />
                                </div>
                                <div className="mb-2 mt-2" style={{ float: "inline-end" }}>
                                    <button type="submit" className="btn btn-theme" onClick={submit}>
                                        Edit Blog
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditBlog